


























import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import iconMap from '@assets/svg/iconMap';

@Component({
	components: {}
})
export default class ToggleScale extends Vue {
	@Model('input')
	protected readonly checked!: boolean;

	@Prop(String)
	protected readonly labelChecked!: string;

	@Prop(String)
	protected readonly labelUnchecked!: string;

	@Prop(String)
	protected readonly iconLeft?: string;

	protected readonly iconMap = iconMap;

	protected onChange(event: Event): void {
		this.$emit('input', (event.target as HTMLInputElement).checked);
	}
}
